module.exports = __webpack_public_path__ + "img/laptop.ff953419.svg";